const apiClient = require('@/api/client.js')

export default {

  getSessionCompany(callback){
    return apiClient.get('/company', null, callback);
  },

  create(company, callback){

    if (!company.first_name){
      return callback(new Error('Invalid first name'))
    }

    if (!company.last_name){
      return callback(new Error('Invalid last name'))
    }

    if (!company.email){
      return callback(new Error('Invalid email'))
    }

    if (!company.phone){
      return callback(new Error('Invalid company phone'))
    }

    if (!company.phone_country){
      return callback(new Error('Invalid company phone country'))
    }

    if (!company.name){
      return callback(new Error('Invalid company name'))
    }

    if (!company.address){
      return callback(new Error('Invalid company address'))
    }

    if (!company.subdomain){
      return callback(new Error('Invalid dashboard URL'))
    }

    if (!company.password){
      return callback(new Error('Invalid password'))
    }

    // This is LD website API key
    return apiClient.makeRequest('POST', '/company', company, {'x-api-key': '899deca0ca2e6763d8068c756a8f575d'}, callback);

  },

  getOrganization(callback){
    return apiClient.makeRequest('GET', '/organization', null, {'x-api-key': '899deca0ca2e6763d8068c756a8f575d'}, callback)
  },

  createOrganization(organization, callback){
    return apiClient.makeRequest('POST', '/organization', organization, {'x-api-key': '899deca0ca2e6763d8068c756a8f575d'}, callback);
  }

}



// WEBPACK FOOTER //
// ./src/components/company/service.js